module.exports = __webpack_public_path__ + "img/loading.05506713.gif";